// extracted by mini-css-extract-plugin
export default {"mainDiv":"Navbar_mainDiv__1Jofq","linkTag":"Navbar_linkTag__Iddxw","image":"Navbar_image__J3p8j","ull":"Navbar_ull__JEkz0","lii":"Navbar_lii__txnew","resume":"Navbar_resume__JsMe2"};